export default __webpack_public_path__ + "static/media/chain-icon.b90b0914.svg";